export const importSamplesWrongVersionDialogStrings = {
    title: 'Falsche Version des Untersuchungsauftrags verwendet',
    message0: `Der Untersuchungsauftrag (ehemals "Einsendebogen") V16 wird ab dem 01.01.2027 nicht mehr akzeptiert.
    Somit können dann - drei Jahre nach Einführung des AVV DatA-Formats - keine ADV-Codes mehr an das BfR gemeldet werden.
    Bitte verwenden Sie nur noch den Untersuchungsauftrag V18 und AVV DatA-Codes.`,
    message1: `Sie haben versucht, einen Untersuchungsauftrag der Version`,
    message2: `hochzuladen.`,
    message3: `Version 16 und frühere Versionen des Untersuchungsauftrags sind für ADV-codierte Daten gedacht.`,
    message4: `Wenn Sie ADV-codierte Daten an das BfR melden möchten, `,
    message5: `laden Sie Ihren Untersuchungsauftrag bitte im "MiBi-Portal ADV" hoch und melden Sie sich dort noch einmal an:`,

    link: 'https://nolar-dev.bfr.berlin/users/login',

    message6Part1: `Dieses MiBi-Portal ist ausschließlich für AVV DatA-codierte Daten vorgesehen,
    die Sie über den Untersuchungsauftrag ab Version`,
    message6Part2: `hier hochladen können.`,

    alternativeMessage2aPart1: `Sie haben versucht, einen Untersuchungsauftrag der Version`,
    alternativeMessage2aPart2: `hochzuladen. Diese Version wird nicht länger unterstützt.`,

    alternativeMessage3aPart1: `Zur Meldung von AVV DatA-codierten Isolatdaten verwenden Sie bitte die aktuelle Version`,
    alternativeMessage3aPart2: `des Untersuchungsauftrags. Sie können diese Version über den Button „Excel-Vorlage“ oben rechts im hellblauen Menüband herunterladen.`,

    cancelButtonText: 'Zurück zum AVV-MiBi-Portal'
};


